module.exports = __webpack_public_path__ + "media/dj.2731c975.mp4";